import React, { Component } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { uuidValidate } from "uuid-validate";
import MetaTags from "react-meta-tags";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import "./css/landing.css"
class LandingPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      templateData: "",
      projectData: "",
      formVisible: true,
      thankYouMessage: '',
      isOpen: false,
      photoIndex: 0,
      images: []
    };

    this.formRef = React.createRef();
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  unlockPageScroll = () => {
    document.documentElement.style.overflowY = "auto";
    document.documentElement.style.height = "auto";
    document.body.style.overflowY = "auto";
    document.body.style.height = "auto";
    document.body.classList.remove("ReactModal__Body--open");

    const wrappers = document.querySelectorAll("#u_body, .u-body");
    wrappers.forEach((el) => {
      el.style.overflow = "visible";
      el.style.height = "auto";
      el.style.maxHeight = "none";
    });
  };

  componentDidMount() {
    const { match: { params } } = this.props;
    const projectId = params.projectId;

    this.unlockPageScroll();
    trackSource();
    axios
      .get(`https://testrsapi.realtyspacehub.com/api/ProjectLandingPage/byprojectguid?guid=${projectId}`)
      .then((res) => {
        this.setState({ templateData: res.data }, this.unlockPageScroll);
      })
      .catch((error) => {
        console.error("There was an error fetching the data!", error);
      });

    axios
      .get("https://testrsapi.realtyspacehub.com/api/ProjectExt/guid", {
        params: { projectid: projectId },
      })
      .then((res) => {
        this.setState({ projectData: res.data });
      })
      .catch((error) => {
        console.error("There was an error fetching project data!", error);
      });
  }

  componentDidUpdate(prevProps, prevState) {
    // Attach listener when HTML template first loads
    if (this.formRef.current && this.state.templateData !== prevState.templateData) {
      const formEl = this.formRef.current.querySelector("form");
      console.log("Found form?", !!formEl);

      if (formEl) {
        formEl.addEventListener("submit", this.handleFormSubmit);
      } else {
        console.warn("⚠ No <form> found. Attaching fallback button click handler...");
        this.attachFallbackButtonClick();
      }
    }

    // Attach image click listeners
    if (
      this.state.templateData !== prevState.templateData ||
      this.state.formVisible !== prevState.formVisible
    ) {
      this.addImageClickListeners();
      this.unlockPageScroll();
    }

    if (prevState.lightboxOpen && !this.state.lightboxOpen) {
      this.unlockPageScroll();
    }
  }

  componentWillUnmount() {
    const formEl = this.formRef.current?.querySelector("form");
    if (formEl) {
      formEl.removeEventListener("submit", this.handleFormSubmit);
    }
    document.documentElement.style.overflowY = "";
    document.documentElement.style.height = "";
    document.body.style.overflowY = "";
    document.body.style.height = "";
    document.body.classList.remove("ReactModal__Body--open");
  }

  attachFallbackButtonClick = () => {
    const btn = this.formRef.current?.querySelector("button, input[type='submit']");
    if (btn) {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        this.handleFormSubmit(e);
      });
    } else {
      console.error("⚠ No submit button found either!");
    }
  };

  addImageClickListeners = () => {
    const images = this.formRef.current?.querySelectorAll(".galleryImg img");
    if (images && images.length > 0) {
      const imageUrls = Array.from(images).map((img) => img.src);
      this.setState({ images: imageUrls });

      images.forEach((img, index) => {
        img.style.cursor = "pointer";
        img.addEventListener("click", () => {
          this.setState({
            lightboxOpen: true,
            photoIndex: index
          });
        });
      });
    }
  };

  handleFormSubmit(event) {
    event.preventDefault();
    const formData = new FormData(event.target);

    const datt = {
      projectCampaignId: 3100,
      agentId: this.state.templateData.agentId,
      projectCampaignGuid: this.props.match.params.projectId,
      campaignProjectId: this.state.templateData.landingPageProjectId,
      campaignProjectGuid: this.props.match.params.projectId,
      leadSourceId: 3,
      firstName: formData.get("first_name"),
      lastName: formData.get("last_name"),
      email: formData.get("email"),
      mobile: formData.get("phone_number"),
      withAgent: formData.get("isrealtor") === "true" ? "true" : "false",
      leadSourceText: '',
    };

    toast.loading("Please wait...");
    axios
      .post("https://rscoreapi.azurewebsites.net/api/ProjectCampaignLead", datt)
      .then((response) => {
        toast.dismiss();

        if (response.data.success) {
          this.setState({
            formVisible: false,
            thankYouMessage: `We will contact you shortly to go over the next steps. If you have questions feel free to call.`,
          });
        } else {
          response.data.validationErrors.forEach((error) => {
            toast.error(error);
          });
        }
      })
      .catch((error) => {
        toast.dismiss();
        toast.error("Error submitting the form");
        console.error("There was an error submitting the form!", error);
      });
  }

  render() {
    const { templateData, projectData, lightboxOpen, photoIndex, images, formVisible, thankYouMessage } = this.state;
       const templateId = templateData?.landingPageTemplateId;
   
    return (
      <React.Fragment>
        <MetaTags>
          <title>{projectData?.projectName || templateData?.landingPageTitle || "Landing Page | Realty Space"}</title>
          {projectData?.projectLogoLink && (
            <link rel="icon" href={projectData.projectLogoLink} />
          )}
        </MetaTags>
        <ToastContainer autoClose={2000} />
        
        {formVisible ? (
          <div
            ref={this.formRef}
            dangerouslySetInnerHTML={{
              __html: templateData.landingPageFullContent || "Loading content..."
            }}
          />
        ) : (
          <div className="text-center">
            <h4 className="text-danger">Thank you </h4>
            {/* <h5>Thank you for submitting the form.</h5> */}
            <h5>{thankYouMessage}</h5>
          </div>
        )}

        {lightboxOpen && images.length > 0 && (
          <Lightbox
            mainSrc={images[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={() => this.setState({ lightboxOpen: false })}
            onMovePrevRequest={() =>
              this.setState({
                photoIndex: (photoIndex + images.length - 1) % images.length
              })
            }
            onMoveNextRequest={() =>
              this.setState({
                photoIndex: (photoIndex + 1) % images.length
              })
            }
          />
        )}
      </React.Fragment>
    );
  }
}

function trackSource() {
  const sourceInfo = {
    source: detectSource(),
    timestamp: new Date().toISOString(),
    browser: navigator.userAgent,
    platform: getPlatform()
  };
  
 
}

function detectSource() {
  const referrer = document.referrer;
  if (referrer.includes("google.com")) return "google";
  if (referrer.includes("facebook.com")) return "facebook";
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("source") || "direct";
}

function getPlatform() {
  const platform = navigator.platform || "unknown";
  return platform.toLowerCase();
}
LandingPage.propTypes = {
  t: PropTypes.any,
  match: PropTypes.object,
  history:PropTypes.object
};
export default connect()(withTranslation()(LandingPage));

